import * as yup from "yup";
import { addKeyToFieldsRecursively } from "@/react/schema/schemaFields";
import {
  MAX_MEMBERS_PER_ROW,
  RING_BACK_MUSIC_CONTINUITY_OPTIONS,
  RING_GROUP_CALLER_ID_OPTIONS,
  RING_PATTERNS,
} from "@/react/features/smp/constants";

/*
 * yup.array().of(memberSchema) does not work in this situation because the
 * internal structure of the schema, although correct, misses key on inner
 * node (members[index]) - which cannot be used in the context of columnDefinition.
 */
const generateMembersSchema = () => {
  let object = {};
  for (let i = 0; i < MAX_MEMBERS_PER_ROW; i++) {
    object[`members[${i}].isActive`] = yup.boolean();
    object[`members[${i}].memberVoiceMailAccess`] = yup.boolean();
    object[`members[${i}].memberSequenceNumber`] = yup.number();
    object[`members[${i}].memberExtensionNumber`] = yup.string();
  }
  return object;
};

const schema = yup.object({
  subscriptionId: yup.string().nullable(),
  name: yup.string().required(),
  extensionNumber: yup.string().nullable(),
  branchName: yup.string().nullable(),
  branchId: yup.string().nullable(),
  primaryDidNumber: yup.string().nullable(),
  details: yup.object({
    numOfCycles: yup.string().nullable(),
    ringPattern: yup.string().oneOf(Object.keys(RING_PATTERNS)).nullable(),
    callerIdOption: yup
      .string()
      .oneOf(Object.keys(RING_GROUP_CALLER_ID_OPTIONS))
      .nullable(),
    ringBackMusicContinuity: yup
      .string()
      .oneOf(Object.keys(RING_BACK_MUSIC_CONTINUITY_OPTIONS))
      .nullable(),
    password: yup.string().nullable(),
    callWaitingDisabled: yup.string().nullable(),
    ringTimer: yup.string().nullable(),
  }),
  ...generateMembersSchema(),
});

addKeyToFieldsRecursively(schema);

export default schema;
